import { endpoints } from './endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://appd.evabtobpp.iasp.tgscloud.net/api',
    providers: endpoints.providers,
  },
  loaderOnHttp: true,
};
